<template>
  <div>
    <v-card-title>
      <h2>Cases</h2>
    </v-card-title>
    <br />
    <div>
        <div>
          <v-text-field
            v-model="searchText"
            :label="`Search ${pagination.totalItems} casetypes`"
            solo
            @keyup.enter="search()"
            style="display: inline-block; width: 67vw;"
          />
          <v-btn 
            color="primary" 
            style="display: inline-block;"
          >
            Search
          </v-btn>
        </div>
        <v-card>
          <v-data-table
            :items="casetypes"
            :headers="headers"
            :pagination.sync="pagination"
            :total-items="totalCaseTypes"
            :rows-per-page-items="paginationStrings"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr>
                <td colspan="4">
                  <div style="text-align:center;padding:25px;">
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No Results</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                @click="$router.push({ name: 'CaseType', params: { id: props.item.id } })"
                style="cursor: pointer;"
              >
                <td style="text-align: center;">
                  <img
                    :src="getIconPath(props.item.id)"
                    style="max-width:50px;max-height:50px;margin:10px;"
                  />
                </td>
                <td
                    style="position:relative;"
                >
                  <div
                    style="font-size: 18px; overflow: hidden;text-overflow: ellipsis;"
                  >
                    {{ props.item.name }}
                    <span
                        v-if="!props.item.enabled"
                        style="font-size: 12px;"
                    >
                        (Closed)
                    </span>
                  </div>
                  <div
                    style="font-size: 14px;"
                  >
                    {{ props.item.desc }}
                  </div>
                </td>
                <td
                  style="vertical-align: middle;margin:5px;text-align:right;"
                >
                  <v-btn
                    icon
                    color="primary"
                  >
                    <v-icon
                      fab
                    >
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'

export default {
  name: 'CaseTypeList',
  mixins: [
    pagination
  ],
  data () {
    return {
      casetypes: [],
      pagination: {},
      searchText: '',
      loading: true,
      paginationStrings: [
        10, 25, 50
      ],
      filter: {},
      filterTags: null,
      filterEnabled: null,
      tagSearch: null,
      tagResults: [],
      newContact: false,
      downloadingCSV: false,
      orgId: null,
      pages: 0,
      headers: [
        { text: '', value: '', sortable: false, width: 75 },
        { text: 'Name', value: 'name' },
        {
          text: '', align: 'right', sortable: false, width: 100
        }
      ],
    }
  },
  created () {
    this.documentTitle('Case Types')
  },
  computed: {
    totalCaseTypes () {
      return this.pagination.totalItems
    }
  },
  methods: {
    getIconPath (id) {
      return api.cases.casetype.icon(id)
    },
    fetch () {
      this.loading = true
      api.cases.casetype.list({
        search: this.searchText,
        ordering: (this.pagination.descending ? '-' : '') + 'name',
        pageNum: this.pagination.page,
        count: this.pagination.rowsPerPage
      })
        .then((data) => {
          this.casetypes = data.results
          this.pagination.page = data.page_number
          this.pagination.totalItems = data.count
          this.pages = data.num_pages
          this.loading = false
          this.componentCreated = true
        })
    },
    search(){
      this.pagination.page = 1
      var queryParam = {}
      if (this.searchText) {
        queryParam['search'] = this.searchText
      }
      this.$router.push({ query:queryParam })
      this.fetch()
    }
  }
}
</script>

<style scoped>

.caseTypeCard {
    background:white;
    border-radius:10px;
    border:1px solid #26262623;
    padding:10px 15px 10px 25px;
    cursor:pointer;
    transition: background 0.4s, box-shadow 0.4s;
}
.caseTypeCard:hover {
    background:#CFD8DC;
    border-radius:10px;
    border:1px solid #26262623;
    padding:10px 15px 10px 25px;
    cursor:pointer;
}

</style>